import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchFavorites } from '../actions/favorites';
import { getDisplayName } from '../helpers/common';

const mapDispatchToProps = {
  fetchFavorites,
};

const withFavoritesFetch = WrappedComponent =>
  connect(null, mapDispatchToProps)(
    class extends React.Component {
      static displayName = `withFavoritesFetch(${getDisplayName(WrappedComponent)})`;

      static propTypes = {
        fetchFavorites: PropTypes.func.isRequired,
      };

      componentDidMount() {
        this.props.fetchFavorites();
      }

      render() {
        const { fetchFavorites: _, ...props } = this.props;

        return (
          <div>
            <WrappedComponent {...props} />
          </div>
        );
      }
    },
  );

export default withFavoritesFetch;



// WEBPACK FOOTER //
// ./src/shared/hocs/withFavoritesFetch.js